
  import faqQuery from '@/apollo/queries/faq/faqQuery'
  import pageMeta from '~/mixins/pageMeta.js';

  export default {
    mixins: [pageMeta],

    props: {
      data: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        pageData: {
          type: Object,
          default: () => {},
        },
        loading: 0,
      };
    },
    apollo: {
      $loadingKey: "loading",
      pageData: {
        prefetch: true,
        query: faqQuery,
        variables() {
          return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
        },
        update(data) {
          return this.$normalizeStrapi(data.faqPage.data);
        },
      },
    },
    computed: {
      generalFaq(){
        const generalFaqObject = {FAQ: this.pageData.General.FAQ};
        return generalFaqObject;
      },
      methodologyFaq(){
        const methodologyFaqObject =  {FAQ: this.pageData.Methodology.FAQ};
        return methodologyFaqObject;
      },
      pageSlug() {
      return this.$route.params.slug;
    }
    },
    methods: {
    },
  }
